import React, { ComponentType, ReactNode } from 'react';
import styles from './horizontal-table.module.scss';
interface HorizontalTableProps {
  data: Record<string, string | number>;
  render?: (key: string, value: string | number) => ReactNode;
}

export const HorizontalTable: ComponentType<HorizontalTableProps> = (props) => {
  const { data, render } = props;
  return (
    <table className={styles.host}>
      <tbody>
        {Object.keys(data).map((key) => (
          <tr key={key}>
            <th>{key}</th>
            <td>
              {render
                ? render(key, data[key])
                : typeof data[key] === 'string'
                ? data[key]
                : JSON.stringify(data[key])}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
